import { render, staticRenderFns } from "./pin-lei-dong-cha.vue?vue&type=template&id=e5e463c2&scoped=true"
import script from "./pin-lei-dong-cha.vue?vue&type=script&lang=js"
export * from "./pin-lei-dong-cha.vue?vue&type=script&lang=js"
import style0 from "./pin-lei-dong-cha.vue?vue&type=style&index=0&id=e5e463c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_00c06ca9196352b30e67b45b8b60d79f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5e463c2",
  null
  
)

export default component.exports